import PropTypes from 'prop-types';

export default function AuthGuard({ children }) {

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };
